/**
 * Language – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Screen from '@screen';

/** Language indicator. */
export default function LanguageIcon({ focused = false, scale = 1 }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${scale * 32 * Screen.widthRatio}`}
      height={`${scale * 29 * Screen.widthRatio}`}
      viewBox={'0 0 32 29'}
    >
      <path
        d='M26.4615 0H5.53389C4.09133 0.00392914 2.69464 0.552779 1.65255 1.54889C0.607925 2.54743 0.00431824 3.91712 1.33514e-05 5.36341L0 5.36842L5.72205e-06 18L1.33514e-05 18.005C0.00431824 19.4513 0.607925 20.821 1.65255 21.8195C2.69464 22.8156 4.09133 23.3645 5.53389 23.3684L5.53847 23.3684H16.5156L22.6588 28.2645C23.1647 28.6676 23.8567 28.7454 24.4395 28.4647C25.0222 28.1839 25.3927 27.5942 25.3927 26.9474V23.3684H26.4615L26.4661 23.3684C27.9087 23.3645 29.3054 22.8156 30.3475 21.8195C31.3921 20.821 31.9957 19.4513 32 18.005L32 18V5.36341C31.9957 3.91712 31.3921 2.54743 30.3475 1.54889C29.3054 0.552779 27.9087 0.00392914 26.4661 6.2909e-06L26.4615 0ZM16.2073 23.1228C16.2077 23.1231 16.2081 23.1234 16.2085 23.1237L16.2073 23.1228ZM26.459 3.36842C27.0583 3.37056 27.6181 3.59972 28.0199 3.98383C28.4191 4.3654 28.6295 4.86581 28.6316 5.37132V17.9971C28.6295 18.5026 28.4191 19.003 28.0199 19.3846C27.6181 19.7687 27.0583 19.9979 26.459 20H23.7085C22.7783 20 22.0243 20.754 22.0243 21.6842V23.4514L18.309 20.4904C18.3086 20.4901 18.3082 20.4898 18.3078 20.4895C17.9047 20.1681 17.408 20 16.9051 20C16.9052 20 16.905 20 16.9051 20H5.54101C4.9417 19.9979 4.3819 19.7687 3.98007 19.3846C3.58082 19.003 3.37044 18.5024 3.36843 17.9968V5.37158C3.37044 4.86598 3.58082 4.36546 3.98007 3.98383C4.3819 3.59972 4.94172 3.37056 5.54105 3.36842H26.459Z'
        clipRule='evenodd'
        fillRule='evenodd'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M5.61328 15.7193C5.61328 14.7891 6.24165 14.0351 7.01679 14.0351H25.5431C26.3182 14.0351 26.9466 14.7891 26.9466 15.7193C26.9466 16.6495 26.3182 17.4035 25.5431 17.4035H7.01679C6.24165 17.4035 5.61328 16.6495 5.61328 15.7193Z'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
    </svg>
  );
}
